import React from "react";
import SideBar from "../components/sideBar";
import Map from "../components/map";
const Layout = ({ children }) => {
  return <div className="layout">{children}</div>;
};
export default Layout;
